import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import LeaguesEventCard from '../LeaguesEventCard';
import { EventCard, CtaCard } from '../../../cards';
import styles from '../../../../pages/ProfilePage/profilePage.scss';
import { EventScheduleTypes } from '../../../../utils/eventConstants';
import { getClickAttrs } from '../../../Analytics/gtag';
import { showCompleteRegistration } from '../../../../utils/events';

const Events = ({ auth, isCurrentUserProfile, type, events, showAll, force, ctaData, search, onHandleTabClick, isProfilePage }) => {
    const history = useHistory();

    const handleTabClick = () => {
        onHandleTabClick(type);
    };

    if ((isCurrentUserProfile && !showAll) || (events?.length > 0)) {
        return (
            <div>
                <div className="row">
                    {events.map((event, i) => {
                        if ((i <= 3 || showAll)) {
                            return (
                                <div
                                    className={`col-12 ${force && force.cardView ? 'col-lg-6' : ''}`}
                                    key={`${type}-event-${i}`}
                                >
                                    {event?.isLeaguesMatch ? (
                                        <LeaguesEventCard session={event} />
                                    ) : (
                                        <EventCard
                                            event={event}
                                            auth={auth}
                                            force={{ cardView: true }}
                                            showCompleteRegistration={showCompleteRegistration(event, auth.user?.claimedPlayer?.playerId)}
                                            isProfilePage={isProfilePage}
                                        />
                                    )}
                                </div>
                            );
                        }
                        return null;
                    })}
                    {isCurrentUserProfile && !showAll && type === EventScheduleTypes.UPCOMING && (!events || events?.length < 2) && ctaData && (
                        <div className={`col-12 col-lg-6`}>
                            <CtaCard
                                data={ctaData.FIND_EVENTS}
                                onCtaClick={() => {
                                    let url = '/search?type=events';
                                    if (search.geocoded) {
                                        url = `/search?type=events&distance=100mi&lat=${search.geocoded.lat}&lng=${search.geocoded.lng}&location=${search.geocoded.location}&locationInputValue=${search.geocoded.location}`;
                                    }
                                    history.push(url);
                                }}
                                className="event-card"
                            />
                        </div>
                    )}
                </div>
                {!showAll && (
                    <div
                        className={`link clickable mt16 ${events.length >= 4 ? 'd-block' : 'd-none'}`}
                        onClick={handleTabClick}
                    >
                        See All Events
                    </div>
                )}
            </div>
        );
    }

    return (
        isCurrentUserProfile ? (
            <div className={`${styles.placeHolderGrid}`}>
                <div className={`${styles.overlay}`} />
                <div className={`${styles.actionWrapper}`}>
                    <button
                        type="button"
                        className={`btn btn-primary btn-sm text-uppercase`}
                        onClick={() => {
                            const url = '/search?type=events';
                            history.push(url);
                        }}
                        {...getClickAttrs({
                            category: `Player Profile`,
                            context: `Events tab - Find event`,
                            location: 'Player Profile CTA',
                        })}
                    >
                        Find Event
                    </button>
                </div>
            </div>
        ) : (
            <div className="row mt64">
                <div className="col-12">
                    <p className="text-center">
                        No events have been added yet<br />
                        Check back for events
                    </p>
                </div>
            </div>
        )
    );
};

Events.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    isProfilePage: PropTypes.bool,
};

Events.defaultProps = {
    isProfilePage: false,
};

export default Events;
